// @ is an alias to /src
import Setting from "../../setting.js";
import PageHeader from "@/components/PageHeaderHome.vue";
import Venues from "@/components/Venues.vue";
import Separator from "@/components/Separator.vue";
import Participants from "@/components/Participants.vue";
import Footer from "@/components/Footer.vue";

import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/pagination/pagination.min.css";

SwiperCore.use([Navigation, Pagination]);

export default {
  name: "Home2024",
  components: {
    PageHeader,
    Venues,
    Separator,
    Participants,
    Footer,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      venues: null,
      alphabet: null,
      slideDetailShow: false,
    };
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log("slide change");
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Scrollbar, A11y], // Pagination           :pagination="{ clickable: true }"
    };
  },
  created() {
    this.axios
      .get(Setting[process.env.NODE_ENV].API + "Venue/GetAll", {
        params: {
          year: 2024,
        },
      })
      .then((response) => {
        if (this.$route.params.season == "SPRING") {
          this.venues = response.data.filter(
            (x) =>
              x.id == 28 ||
              x.id == 29 ||
              x.id == 30 ||
              x.id == 31 ||
              x.id == 32 ||
              x.id == 33 ||
              x.id == 34 ||
              x.id == 35 ||
              x.id == 36 ||
              x.id == 37
          );
        } else if (this.$route.params.season == "FALL") {
          this.venues = response.data.filter(
            (x) =>
              x.id == 38 ||
              x.id == 39 ||
              x.id == 40 ||
              x.id == 41 ||
              x.id == 42 ||
              x.id == 43 ||
              x.id == 44 ||
              x.id == 45 ||
              x.id == 46 ||
              x.id == 47 ||
              x.id == 48
          );
        }
      });

    this.axios
      .get(Setting[process.env.NODE_ENV].API + "Venue/GetBands", {
        params: {
          year: 2024,
        },
      })
      .then((response) => {
        this.alphabet = response.data;
      });
  },
  methods: {
    onShowHideSlideDetail() {
      if (!this.slideDetailShow) {
        this.slideDetailShow = true;
      } else {
        this.slideDetailShow = false;
      }
    },
    onClick() {
      this.slideDetailShow = false;
    },
  },
};
